import { FormControl } from '@angular/forms';

export const noWhitespaceValueValidator = (control: FormControl) => {
  const isWhitespace = (control.value || '').trim().length === 0;
  const isValid = !isWhitespace;

  return isValid ? null : { whiteSpace: true };
};
